import HeaderAdmin from '../components/HeaderAdmin';
import LeftSideBarAdmin from '../components/LeftSideBarAdmin';
import 'react-toastify/dist/ReactToastify.css';
import './admin-buttons.css';
import FloatingSupportWidget from '~/components/FloatingSupportWidget';

import { useEffect } from 'react';

function AdministratorLayout({ children }) {
    useEffect(() => {
        document.body.classList.add('administrator-layout');
        return () => {
            document.body.classList.remove('administrator-layout');
        }
    }, []);

    return (
        <main className='main administrator-layout'>
            <LeftSideBarAdmin />
            <HeaderAdmin />
            <div className='content'>{children}</div>
            <FloatingSupportWidget />
        </main>
    )
}
export default AdministratorLayout;